// extracted by mini-css-extract-plugin
module.exports = {"Btn":"Btn__Btn__1UBrv","Primary":"Btn__Primary__19yAF","Secondary":"Btn__Secondary__hy37p","Pagination":"Btn__Pagination__3MiMp","enable":"Btn__enable__20847"};